import {useEffect, useRef, useCallback} from 'react';
import {ScoreController} from '../../components/score-controller.js';
import {JiggleComponent} from '../components/jiggle-component.js';

export const useJiggle = (speed: number = 40.0, amplitude: number = 0.001) => {
    const jiggleRef = useRef(null);
    const jiggleComp = useRef<JiggleComponent | null>(null);

    useEffect(() => {
        if (jiggleRef.current === null) {
            return;
        }

        let comp = jiggleRef.current.getComponent(JiggleComponent);
        if (!comp) {
            comp = jiggleRef.current.addComponent(JiggleComponent, {
                jiggleSpeed: speed,
                jiggleAmplitude: amplitude,
            });
        }
        jiggleComp.current = comp;

        const raiseUrgency = () => comp.startJiggle();
        const lowerUrgency = () => comp.stopJiggle();

        ScoreController.instance.addRaiseUrgencyDelegate(raiseUrgency);
        ScoreController.instance.addLowerUrgencyDelegate(lowerUrgency);

        return () => {
            if (jiggleRef.current) {
                let comp = jiggleRef.current.getComponent(JiggleComponent);
                if (comp) {
                    comp.stopJiggle();
                }
                jiggleRef.current.removeComponent(JiggleComponent);
            }
            ScoreController.instance.removeRaiseUrgencyDelegate(raiseUrgency);
            ScoreController.instance.removeLowerUrgencyDelegate(lowerUrgency);
        };
    }, [speed, amplitude]);

    const triggerJiggle = useCallback((duration: number) => {
        if (!jiggleComp.current) {
            return;
        }

        jiggleComp.current.startJiggle(duration);
    }, []);

    const stopJiggle = useCallback(() => {
        if (jiggleComp.current) {
            jiggleComp.current.stopJiggle();
        }
    }, []);
    return {jiggleRef, triggerJiggle, stopJiggle};
};
